import React from 'react';  
import { Redirect, Route  } from 'react-router-dom';

import { userGroupUrlCheck} from '../utils/userGroupUrlCheck';
import * as staticConfigs from '../configs/staticConfigs';

const PrivateRoute = ({ component: Component, ...rest }) => {
    

    let loginRoute = '';
    let location   = rest.location.pathname;

    let userGroupData = userGroupUrlCheck(rest.location);
    let userGroup = ''; 
    let userGroupToken = null;

    if(userGroupData!==undefined){
        userGroup = userGroupData.user_group; 
        userGroupToken = userGroupData.accessToken;
    }  
    
    if(userGroup===staticConfigs.LOGIN_SUPER_ADMIN_GROUP){
        loginRoute = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN;
    }else if(userGroup===staticConfigs.LOGIN_AFFILIATE_GROUP){
        loginRoute = staticConfigs.LOGIN_ROUTE_AFFILIATE;
    }else if(userGroup===staticConfigs.LOGIN_CLIENT_GROUP){
        loginRoute = staticConfigs.LOGIN_ROUTE_CLIENT;
    }else{
        if(location.includes(staticConfigs.LOGIN_ROUTE_SUPER_ADMIN+'/')){
            loginRoute = staticConfigs.LOGIN_ROUTE_SUPER_ADMIN;
        }else if(location.includes(staticConfigs.LOGIN_ROUTE_AFFILIATE+'/')){
            loginRoute = staticConfigs.LOGIN_ROUTE_AFFILIATE;
        }else if(location.includes(staticConfigs.LOGIN_ROUTE_CLIENT+'/')){
            loginRoute = staticConfigs.LOGIN_ROUTE_CLIENT; 
        }else{
            loginRoute= ''; // need to do later
        }
    }

    if(userGroupToken !== null){
        return (
            <Route {...rest} render={(props) => (
                <Component { ...props } />
            )}/>
        )
    }
    return (        
        <Route {...rest} render={(props) => (
            <Redirect to={{
                pathname: loginRoute,
                state: { from: props.location }
              }}
            />
        )}/>
    )

}


export default PrivateRoute; 